<template>
  <section class="mt-3 carpet-chart-container" id="chart">
    <b-row v-if="charts.length > 1">
      <b-col md="6">
        <b-input-group prepend="Min/Max">
          <b-select v-model="abs_min_max">
            <option :value="true">Assoluti</option>
            <option :value="false">Relativi</option>
          </b-select>
        </b-input-group>
      </b-col>
    </b-row>
    <div id="charts" v-for="(item, i) in charts" :key="i">
      <b-row style="padding-bottom: 10px">
        <b-col>
          Min: <input type="text" v-model="manualMin">
          Max: <input type="text" v-model="manualMax">
          <b-btn @click="reload()">
            <font-awesome-icon icon="sync" />
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <table class="table" id="carpet">
            <tr>
              <td>
                <apexchart type="heatmap" height="500" :options="item.options" :series="item.series"></apexchart>
                <!--<p>Min: <strong>{{ item.options.min }}</strong> - Max: <strong>{{ item.options.max }}</strong></p>-->
              </td>
              <td style="width:120px" class='meter-bar'>
                <img id="meter" src="/static/heatmap.png" alt="heat meter" />
                <span class='meter-top'>{{item.options.max}} [{{ item.mu }}]</span>
                <span class='meter-med'>{{ ((item.options.max - item.options.min) / 2).toFixed(0) }} [{{ item.mu }}]</span>
                <span class='meter-bot'>{{item.options.min}} [{{ item.mu }}]</span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import NeedUpdateMixin from "../../NeedUpdateMixin";

var moment = require('moment');
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

export default {
  name: 'CarpetChart',
  props: ['filter', 'loading'],

  mixins: [NeedUpdateMixin],

  created() {
    this.reload()
  },

  data() {
    return {
      charts: [],
      options: {
        chart: {
          id: 'carpet-chart',
          locales: this.getChartsLocales(),
          defaultLocale: "it",
          animations: {
            enabled: false
          },
          toolbar: {
              tools: {
                  download: false
              }
          }
        },
        legend: {
          show: false
        },
        stroke: {
          show: false,
          width: 0,
        },
        colors: ["#eeeeee"],
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          y: {
            formatter: x => this.f(x)
          }
        }
      },
      series: [],
      abs_min_max: true,
      min_max: {

      },
      manualMin: '',
      manualMax: ''
    }
  },

  methods: {
    reload() {
      if (this.loading) {
        return;
      }

      if(this.filter.channels.length || this.filter.parameters.length) {

        if(this.loading != 'silent')
          this.$store.commit("loading")

        this.$store.dispatch('charts/get', this.filter).then( (data) => {
          this.charts = []

          let count = data.columns.length + data.parameters.length

          for(let chartIndex=1; chartIndex<count; chartIndex++) {
            var mu = data.mus[chartIndex - 1]
            if(! this.min_max[mu])
              this.min_max[mu] = { min: null, max: 0}

            data.values.forEach(v => {
              let value = v[chartIndex] != undefined ? v[chartIndex] : null
              this.min_max[mu].max = Math.max(this.min_max[mu].max, value)
              if(value != null && value != undefined)
                this.min_max[mu].min = this.min_max[mu].min == null ? value : Math.min(this.min_max[mu].min, value)
            })
          }

          for(let chartIndex=1; chartIndex<count; chartIndex++) {

            let series = []
            for(let h=0; h<24; h++) {
              series.push({
                name: _.padStart(h.toString(), 2, '0'),
                data: []
              })
            }

            var mu = data.mus[chartIndex - 1]

            let options = _.cloneDeep(this.options)
            options.min = null
            options.max = 0

            data.values.forEach(v => {
              let date = moment.utc(v[0], "YYYY-MM-DD HH:mm:ss", 'it', true)

              let h = parseInt(date.format("HH"))
              let value = v[chartIndex] != undefined ? v[chartIndex] : null

              let inSerie = series[h].data.find( e => e.x == date.format("ddd D MMM"))
              if(! inSerie) {
                series[h].data.push({
                  x: date.format("ddd D MMM"),
                  y: v[chartIndex]
                })
              } else {
                if(inSerie.x == null && value != null)
                  inSerie.x = value
              }

              if(value != null) {
                options.max = Math.max(options.max, value)
                options.min = options.min == null ? value : Math.min(options.min, value)
              }
            })

            let isConsumption = chartIndex < data.columns.length
            if(isConsumption) {
              options.title = {
                text: data.columns[chartIndex]
              }
            } else {
              options.title = {
                text: data.parameters[chartIndex - data.columns.length].parameterName
              }
            }

            let color = isConsumption ? '#ff0000' : '00ff00'
            options.plotOptions = {
              heatmap: {
                radius:0,
                enableShades: false,
                distributed: false,
                colorScale: {
                  ranges: []
                },
              }
            }

            let colors = ["#00009a","#0200ad","#0000bc","#0000cf","#0000de","#0401ee","#0000fe","#000fff","#001ffe","#022eff","#003fff","#004eff","#005ffe","#0071fe","#0185fd","#0298ff","#02acff","#00bfff","#03cfff","#02dfff","#00effc","#01ffff","#0fffee","#1fffdd","#30fece","#3dffbf","#4ffeaf","#5ffe9d","#71fe8e","#85fe77","#97fe67","#aaff50","#beff41","#cfff2e","#e0ff1f","#eeff0b","#ffff01","#fdef01","#ffdf00","#ffcf00","#fcbf00","#ffaf00","#fea002","#ff8f00","#fe8000","#fd6802","#fc5501","#ff4000","#fe2f02","#ff1e00","#ff0e02","#fe0000","#ec0100","#de0101","#cf0000","#be0002","#ae0001","#a00000","#8e0100","#790304"]

            let min = this.abs_min_max ? this.min_max[mu].min : options.min
            let max = this.abs_min_max ? this.min_max[mu].max : options.max

            if(this.manualMin.length > 0)
              min = parseInt(this.manualMin)

            if(this.manualMax.length > 0)
              max = parseInt(this.manualMax)

            var split = (max - min) / colors.length

            options.min = min
            options.max = max

            for(let i=0; i<colors.length; i++) {
              options.plotOptions.heatmap.colorScale.ranges.push({
                from: (i * split) + min,
                to: (i + 1) * split + min,
                color: colors[i],
                name: (i * split + min).toFixed(0) + " - " + ((i + 1) * split + min).toFixed(0)
              })
            }

            this.charts.push({ series, options, mu: data.mus[chartIndex - 1] })

            setTimeout(() => {
              this.setDataValues()
            }, 100)
          }
        })
        .finally(() => {
          this.$store.commit("stopLoading");
        })
      }
    },
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
    setDataValues() {
      var rects = document.getElementsByClassName("apexcharts-heatmap-rect");
      for(var i in rects) {
          if(rects[i].getAttribute) {
            var val = parseFloat(rects[i].getAttribute('val'))
            var col = rects[i].getAttribute("fill")
            if(! isNaN(val)) {
              rects[i].setAttribute("data-value", val)
              rects[i].setAttribute("data-color", col)
            }
          }
        }
    },
    updateColor(element) {
      if(element.getAttribute) {
        var val = parseFloat(element.getAttribute('data-value'))
        var col = element.getAttribute('data-color')

        if(val < this.manualMin || (this.manualMax != null && ! isNaN(this.manualMax) && val > this.manualMax)) {
          element.setAttribute("fill", "#d7d7d7")
        } else {
          element.setAttribute("fill", col)
        }
      }
    }
  },

  watch: {
    filter() {
      _.debounce(this.reload, 10)();
    },
    abs_min_max() {
      this.reload()
    },
  }
}
</script>
<style>
#meter {
  height: 369px;
  top: 51px;
  position:absolute;
}
table#carpet td {
  padding: 0;
}
.meter-bar {
  position:relative;
}
.meter-bar span {
  position: absolute;
  left: 20px;
  font-size:12px;
}
.meter-bar span.meter-top {
  top:46px;
}
.meter-bar span.meter-med {
  top:226px;
}
.meter-bar span.meter-bot {
  top:411px;
}
.carpet-chart-container .apexcharts-xaxis text {
  opacity: 0;
}
.carpet-chart-container .apexcharts-xaxis text:nth-child(7n) {
  opacity: 1;
}
</style>




// WEBPACK FOOTER //
// src/components/Charts/Types/Apex/Carpet.vue